<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/129/base.png" alt="" />
            <div class="technological-process">
                <div class="zcjj">
                    <img
                        class="top"
                        style="height: 1.12rem"
                        src="./../assets/imgs/xllh/rcgyysq_zcjj.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="des">
                            为加强和规范成都市职业技能竞赛活动，完善优秀高技能人才选拔机制，营造尊重劳动社会氛围，不断深化“技能成都”建设，实现人力资源高质量协同、城市高质量发展，努力打造技能人才高地，根据国家、省、市有关规定，给予职业技能竞赛获奖人员相关奖励。
                        </div>
                    </div>
                </div>
                <div class="rhtj mar-t2">
                    <img
                        class="top"
                        src="./../assets/imgs/129/label1.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="des mar-t2">
                            <div class="describe mar-t2">
                                （一）获得世界技能大赛金牌、银牌、铜牌、优胜奖的选手，按项目给予通报表扬和现金奖励。
                                <br />
                                1．获得金牌的选手，奖励人民币50万元；<br />
                                2．获得银牌的选手，奖励人民币30万元;<br />
                                3．获得铜牌的选手，奖励人民币20万元;<br />
                                4．获得优胜奖的选手，奖励人民币10万元。
                            </div>
                        </div>
                        <div class="des mar-t2">
                            <div class="describe mar-t2">
                                （二）获得中华人民共和国职业技能大赛金牌、银牌、铜牌、优胜奖的选手，按项目给予通报表扬和现金奖励。
                                <br />
                                1．获得金牌的选手，奖励人民币10万元;<br />
                                2．获得银牌的选手，奖励人民币5万元;<br />
                                3．获得铜牌的选手，奖励人民币3万元;<br />
                                4．获得优胜奖的选手，奖励人民币2万元。
                            </div>
                        </div>
                        <div class="des mar-t2">
                            <div class="describe mar-t2">
                                （三）获得其他国家、省、市重要赛事活动一、二、三等奖（或金、银、铜牌）的选手，竞赛组织单位可根据竞赛计划和资金预算，按项目给予通报表扬和现金奖励。
                                <br />
                                1．国家级一类竞赛一、二、三等奖的获奖选手，分别奖励人民币5万元、3万元、2万元;<br />
                                2．国家级二类竞赛和四川省级一类竞赛一、二、三等奖的获奖选手，分别奖励人民币3万元、2万元、1.6万元;<br />
                                3．四川省级二类竞赛和成都市级一类竞赛一、二、三等奖的获奖选手，分别奖励人民币2万元、1.6万元、1万元;<br />
                                4．成都市级二类竞赛一、二、三等奖的获奖选手，分别奖励人民币1.6万元、1万元、0.8万元。
                            </div>
                        </div>
                        <div class="des mar-t2">
                            <div class="describe mar-t2">
                              （四）获得成都市级一类竞赛一、二、三等奖（或金、银、铜牌）和成都市级二类竞赛一等奖（或金牌）的选手，由市人社局授予“成都市技术能手”称号，颁发荣誉证书。
                            </div>
                        </div>
                        <div class="des mar-t2">
                            <div class="describe mar-t2">
                              （五）纳入成都市年度竞赛计划，按照《国家职业标准》或相应职业技能标准组织的市、县级职业技能竞赛，竞赛主办单位可向市人社局申请，由市职建中心按规定为竞赛获奖选手晋升职业技能等级或颁发相应职业证书（职业资格证书、技能等级证书、专项职业能力证书或其他职业证书)。
                            </div>
                        </div>
                        <!-- <div class="des mar-t2">
                            <div class="describe mar-t2">
                              （六）承担我市选手集训任务，指导选手在省级以上重大赛事活动中获得优异成绩的，给予教练团队通报表扬和获奖选手同等标准的现金奖励。给予集训单位通报表扬，颁发“成都市职业技能竞赛优秀集训单位”奖牌。
                            </div>
                        </div>
                        <div class="des mar-t2">
                            <div class="describe mar-t2">
                              （七）组队参加或具体承办成都市级职业技能竟赛，并在竞赛中取得优异成绩或组织工作突出的单位，可由竟赛主办单位和市人社局给予通报表扬，颁发“成都市职业技能竞赛优秀组织奖”奖牌。
                            </div>
                        </div>
                        <div class="des mar-t2">
                            <div class="describe mar-t2">
                              （八）未纳入年度竞赛计划或资金预算的其他市级部门主办或组队参加的省级以上、市级竞赛，各区（市）县组织的县级竞赛，以及竞赛组织单位组织的其他竞赛，奖励项目和奖励标准等由竞赛组织单位自行确定。
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="contact">
                    <img
                        class="top"
                        src="./../assets/imgs/129/label2.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61888231">028-61888231</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市人力资源和社会保障局职业能力建设处
                        </div>
                    </div>
                </div>

            </div>
        </section>
        <call phone="028-61888231"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        // bottom,
        call,
    },

    mounted() {},

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .zcjj {
            // background-color:#fff;
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.1rem 0.33rem 0.4rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                line-height: 0.44rem;

                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;
                    text-align: left;
                    margin-top: 0.16rem;
                }
            }
        }

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem 0.3rem;
                    text-align: left;
                    line-height: 0.44rem;
                    position: relative;

                    .describe {
                        background: linear-gradient(
                            180deg,
                            #ffffff 0%,
                            rgba(255, 255, 255, 0) 100%
                        );
                        border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                        opacity: 1;
                        padding: 0rem 0.33rem 0 0.15rem;

                        .num {
                            min-width: 0.39rem;
                            height: 0.39rem;
                            background: #739bfe;
                            color: #ffffff;
                            display: inline-flex;
                            border-radius: 50%;
                            justify-content: center;
                            align-items: center;
                            margin-right: 0.14rem;
                        }
                    }

                    img {
                        position: absolute;
                        width: 1.74rem;
                        height: 0.6rem;
                        top: 0;
                        left: 0;
                    }
                }
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.68rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;

                    .title-img {
                        position: absolute;
                        left: 50%;
                        top: 0rem;
                        width: 4.46rem;
                        height: 0.67rem;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                            line-height: 0.46rem;
                        }

                        .line-top {
                            display: flex;

                            .line-num {
                                min-width: 0.39rem;
                                height: 0.39rem;
                                background: #739bfe;
                                color: #ffffff;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }

                    .des-item {
                        font-size: 0.26rem;
                        font-weight: 500;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        border-left: 0.02rem dashed #739bfe;
                        padding-bottom: 0.55rem;

                        .cdrcwewm {
                            width: 5.51rem;
                            height: 1.43rem;
                            margin-top: 0.16rem;
                        }
                    }

                    .describe-item {
                        font-size: 0.26rem;
                        font-weight: 500;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        word-break: break-all;
                    }
                }
            }
        }

        .sqsj {
            width: 6.85rem;
            background: #ffffff;
            border-radius: 0.26rem 0.26rem 0.26rem 0.26rem;
            margin: 0.3rem auto 0;
            box-sizing: border-box;
            text-align: left;
            padding: 0.3rem;
            padding-bottom: 0.15rem;

            .rcrclc-sqsj {
                width: 5.58rem;
                height: 1.94rem;
                margin-top: 0.3rem;
                background-image: url("./../assets/imgs/xllh/rcrclc_sqsj.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                margin: 0 auto;

                img {
                    width: 1.94rem;
                    height: 1.94rem;
                }
            }

            .rcrclc-zhfwpt {
                width: 5.58rem;
                height: 1.94rem;
                margin-top: 0.3rem;
                background-image: url("./../assets/imgs/xllh/rcrclc_zhfwpt.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                margin: 0.3rem auto 0;

                img {
                    width: 1.94rem;
                    height: 1.94rem;
                }
            }
        }
    }
}
</style>
